var map = {
	"./course/course.module.ngfactory": [
		"./src/app/course/course.module.ngfactory.js",
		"default~course-course-module-ngfactory~onsite-lector-onsite-lector-module-ngfactory",
		"course-course-module-ngfactory"
	],
	"./onsite-lector/onsite-lector.module.ngfactory": [
		"./src/app/onsite-lector/onsite-lector.module.ngfactory.js",
		"default~course-course-module-ngfactory~onsite-lector-onsite-lector-module-ngfactory",
		"onsite-lector-onsite-lector-module-ngfactory"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;